<template>
  <div>
    <el-col>
      <h4 class="h4">
        <i class="el-icon-s-management"></i>&nbsp;&nbsp;{{ $t('preprint.submitInfo.title') }}
      </h4>
    </el-col>

    <el-form ref="preprintForm" :model="preprintInfo" label-width="100px">
      <el-form-item :label="$t('preprint.submitInfo.titleLabel')" prop="title" required>
        <el-input
          v-model="preprintInfo.title"
          :placeholder="$t('preprint.submitInfo.titlePlaceholder')"
          size="medium"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('preprint.submitInfo.typeLabel')" prop="preprintType" required>
        <el-select
          style="width: 100%"
          size="medium"
          v-model="preprintInfo.preprintType"
          :placeholder="$t('preprint.submitInfo.typePlaceholder')"
        >
          <el-option :label="$t('preprint.typePhysiology')" value="生理实验"></el-option>
          <el-option :label="$t('preprint.typeAcoustics')" value="声学实验"></el-option>
          <el-option :label="$t('preprint.typePsychology')" value="心理实验"></el-option>
          <el-option :label="$t('preprint.typeNeuroscience')" value="神经科学"></el-option>
          <el-option :label="$t('preprint.typeModeling')" value="建模仿真"></el-option>
          <el-option :label="$t('preprint.typeTheory')" value="理论探索"></el-option>
          <el-option :label="$t('preprint.typeReview')" value="评述推介"></el-option>
          <el-option :label="$t('preprint.typeNews')" value="学术资讯"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('preprint.submitInfo.abstractLabel')" prop="abstractText" required>
        <el-input
          type="textarea"
          :placeholder="$t('preprint.submitInfo.abstractPlaceholder')"
          :rows="15"
          v-model="preprintInfo.abstractText"
          size="medium"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('preprint.submitInfo.keywordsLabel')" prop="keywords" required>
        <el-input
          type="textarea"
          :placeholder="$t('preprint.submitInfo.keywordsPlaceholder')"
          :rows="3"
          v-model="preprintInfo.keywords"
          size="medium"
        ></el-input>
      </el-form-item>
    </el-form>

    <el-row></el-row>
    <br />
    <el-col class="h4">
      <el-button class="save" @click="saveInfo">{{ $t('preprint.submitInfo.saveButton') }}</el-button>
    </el-col>
  </div>
</template>

<script>
export default {
  name: 'PreprintInfoComponent',
  data() {
    return {
      userInfo: null,
      preprintInfo: {
        title: '',
        preprintType: '',
        abstractText: '',
        keywords: ''
      }
    }
  },
  methods: {
    saveInfo() {
      if (!this.preprintInfo.title) {
        this.$message.warning(this.$t('preprint.submitInfo.titleRequired'))
        return
      }
      if (!this.preprintInfo.preprintType) {
        this.$message.warning(this.$t('preprint.submitInfo.typeRequired'))
        return
      }
      if (!this.preprintInfo.abstractText) {
        this.$message.warning(this.$t('preprint.submitInfo.abstractRequired'))
        return
      }
      if (!this.preprintInfo.keywords) {
        this.$message.warning(this.$t('preprint.submitInfo.keywordsRequired'))
        return
      }

      // 保存到全局状态
      this.$root.$emit('savePreprintInfo', this.preprintInfo)
      this.$message.success(this.$t('preprint.submitInfo.saveSuccess'))
    },
    loadSavedInfo() {
      const saved = sessionStorage.getItem('preprintInfo')
      if (saved) {
        this.preprintInfo = JSON.parse(saved)
      }
    }
  },
  mounted() {
    this.userInfo = this.$cookie.getCookie('userInfo')
    this.loadSavedInfo()

    // 监听保存事件
    this.$root.$on('savePreprintInfo', (info) => {
      sessionStorage.setItem('preprintInfo', JSON.stringify(info))
    })

    // 监听加载预印本数据事件（重新提交模式）
    this.$root.$on('loadPreprintData', (data) => {
      if (data) {
        this.preprintInfo = {
          title: data.title || '',
          preprintType: data.preprintType || '',
          abstractText: data.abstractText || '',
          keywords: data.keywords || ''
        }
        // 同时保存到 sessionStorage
        sessionStorage.setItem('preprintInfo', JSON.stringify(this.preprintInfo))
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('savePreprintInfo')
    this.$root.$off('loadPreprintData')
  }
}
</script>

<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}

.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}

button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/preprint/preprintInfoComponent.vue